import { Phone, Mail, Globe } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/10 bg-ark-950 py-14">
    <WhatsAppButton />
    <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="ARK IT ENTERPRISES" className="h-12 w-12 rounded-full ring-1 ring-white/20" />
          <div className="leading-tight">
            <p className="font-display font-extrabold tracking-wide text-white">ARK IT ENTERPRISES</p>
            <p className="font-mono text-[10px] tracking-[0.3em] text-cyan-400">IT INFRASTRUCTURE &amp; SOLUTIONS</p>
          </div>
        </div>
        <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
          Professional IT Support • Security • Connectivity • Business Solutions
        </p>
      </div>

      <div>
        <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500 uppercase mb-4">Navigate</p>
        <div className="flex flex-col gap-2.5">
          {["services", "offerings", "coverage", "about", "contact"].map((id) => (
            <button
              key={id}
              data-testid={`footer-link-${id}`}
              onClick={() => scrollToId(id)}
              className="text-left text-sm text-slate-400 hover:text-cyan-300 transition-colors capitalize w-fit"
            >
              {id}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500 uppercase mb-4">Reach Us</p>
        <div className="space-y-2.5 text-sm text-slate-400">
          <a data-testid="footer-phone-link" href="tel:+919619923347" className="flex items-center gap-2.5 hover:text-cyan-300 transition-colors">
            <Phone size={13} className="text-cyan-400/70" /> +91 9619923347
          </a>
          <a data-testid="footer-email-link" href="mailto:info@arkitenterprises.in" className="flex items-center gap-2.5 hover:text-cyan-300 transition-colors">
            <Mail size={13} className="text-cyan-400/70" /> info@arkitenterprises.in
          </a>
          <a data-testid="footer-website-link" href="https://www.arkitenterprises.in" target="_blank" rel="noreferrer" className="flex items-center gap-2.5 hover:text-cyan-300 transition-colors">
            <Globe size={13} className="text-cyan-400/70" /> www.arkitenterprises.in
          </a>
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
      <p className="font-mono text-[11px] text-slate-600">
        © {new Date().getFullYear()} ARK IT ENTERPRISES. All rights reserved.
      </p>
      <p className="font-mono text-[11px] text-slate-600">
        Pan-India • US • UK • UAE • Australia • Canada
      </p>
    </div>
  </footer>
);
